export default {
	logoName:'Учет догооворов и управление закупками',
	logOut:'Выйти',
	save :"Сохранять",
	reset:"Перезагрузить",
	kycForm:{
		lastName:"Фамилия",
		firstName:"Имя",
		surName:"Отчество",

		lastNameEn:"Фамилия Латиница",
		firstNameEn:"Имя Латиница",
		surNameEn:"Отчество Латиница",
		birthDate:"Дата рождения",
		birthPlace:"Место рождения",
		iin:"ИИН",
		citizen:"Гражданство",
		isPep:"Причастность к ПДЛ",
		Yes:"Да",
		No:"Нет",

		pepPosition:"Должность ПДЛ",
		pepFio:"ФИО ПДЛ",
		pepRelDeg:"Взаимосвязь ПДЛ",
		pepInvolvement:"Причастность ПДЛ ",
		pepLabel:"Источник метки ПДЛ ",

		docType:"Тип документа",
		kycNumber:"Номер",
		kycSerial:"Серия",
		kycIssuedBy:"Кем выдан",
		kycGivenDate:"Дата выдачи",
		kycTillDate:"Срок действия",
		isLiveKaz:"Признак резиденства РК",
		livingCountry:"Страна резиденства",
		sectorEconomy:"Сектор экономики",
		oked:"ОКЭД",
		kbe:"КБЕ",

		phoneNumber:"Контактный телефон",
		phoneNumberHome:"Домашний телефон",
		phoneNumberWork:"Рабочий телефон",
		email:"E-mail",

		regCountry:"Страна",
		regIndex:"Индекс",
		regRegion:"Регион",
		regCity:"Город/населенный пункт",
		regAddr:"Адрес",
		jobAddr:"Место работы ",
		jobTitle:"Должность",
		jobBusinessPurpose:"Цель деловых отношений",
		jobBusiness:"Характер деловых отношений",


		riskDegree:"Уровень риска",
		riskDeterDegree:"Определение уровня риска",
		monthlyInvestLimit:"Лимит инвестирования в месяц",
		clientType:"Тип клиента",
		statusClient:"Статус клиента",
		clientClassification:"Классификация клиента",
		surveyEndDate:"Дата прекращения анкеты",
		testResult:"Результаты тестирования",
		anketCreatedDate:"Дата создания анкеты",
		idAccount:"ID аккаунта",
		accountCreatedDate:"Дата создания аккаунта",


		riskCountry:"Страна фактического проживания",
		riskIndex:"Индекс фактического проживания",
		riskRegion:"Регион фактического проживания",
		riskCity:"Город/населенный пункт проживания",
		riskAddr:"Адрес фактического проживания",
		riskWorkPlace:"Место работы",
		riskPosition:"Должность",
		riskFundingSource:"Вид источника финансирования",
		riskFinancial:"Характеристика финансирования",

		birthPlaceEn:"Место рождения",
		clientLimit:"Лимит инвестирования в месяц",
		clientClassification:"Классификация клиента",
		clientStatus:"Статус клиента",
		resultTest:"Результаты тестирования",
		sysFilleddDate:"Дата создания анкеты",
		sysSurveyAndDate:"Дата прекращения анкеты",
		sysId:"ID аккаунта",
		sysCreatedDate:"Дата создания аккаунта",
		createdContractNumber:"Номер заключенного договора",
		buisnessReput:"Информация о деловой репутации",
		contractTerminateddDate:"Дата прекращения договора",
		contractTerminatedReason:"Основания прекращения договора",
		monitoringResult:"Результаты мониторинга операции",
		uploadPlace:"Место для загрузки документа, удостоверяющий личность"
	},
	regForm:{
		changePassword:"изменить пароль",
		phoneNumber:"Телефон",
		country:"Страна",
		fio:"ФИО",
		iin:"ИИН",
		orgBin:"БИН",
		orgName:"Наименование организации",
		email:"Электронная почта",
		password:"Пароль",
		passwordRe:"Повторите пароль",
		passwordrepeat:"Повторите пароль",
		createAccount:"Продолжать",
		accountCreated:"Аккаунт создан",
		login:"Войти",
		loginText:"Войти",
		forgotPassword:"Забыли пароль ?",
		wrongLogin:"Неверный email или пароль.",
		emailNotVerified:"Email не подтверждён. Введите код из письма, чтобы завершить регистрацию.",
		emailAlreadyRegistered:"Этот email уже зарегистрирован. Если вы забыли пароль — воспользуйтесь восстановлением пароля.",

	},
	ex:{
		chooseOrgFile:"Выберите файл",
		noFile:"Файл не выбран",
		takeSelfie:"сделай селфи и нажми кнопку выбора",
		userDub:"Электронная почта или иин номер уже зарегистрированы.",
		mainMenu:{
			exchange:"Обмен",
			login:"Войти",
			reg:"Регистрация",
			buy:"Купить",
			sell:"Продать",
		},
		home:{
			mainBanner:{
				title:"Инвестируйте в криптовалюту",
				description:"Покупайте и продавайте цифровые активы на удобном сервисе Payton.kz",
				cryptoBtn:"Исследуйте криптовалюту"
			}
		}
	},
	
	system:{
		errorTitle:'ошибка',
		warningTitle:'Внимание',
		successTitle:"Успех",
		successMsg:"Успешно завершено",
		dublicationMsg:'Повторяющаяся запись !!!',
		newRecord:'Новая запись',
		confirmMsg:'Вы уверены ?',
		selectAll:'Выбрать все',
		unSelectAll:'Снять все',
		status:'Статус',
		beginDate:"Дата начала",
		endDate:"Дата окончания",
		search:"Поиск",
		loading:"Загрузка",
		add:'добавить',
		delete:'удалять',
		update:'Обновить',
		failMsg: 'Обнаружена неизвестная ошибка. Пожалуйста, попробуйте еще раз .',
		delete:"Удалить",
		update:"Обновлять"
	},

	project:{
		downloadFile:"Скачать файл",
		delFile:"Удалить файл",
		delFileConfirm:"Вы уверены, что хотите удалить этот файл?",
		files:"Документы",
		done:"Выполнено",
		decline:"Отклонено",
		budgetNotes:"Бюджетные заметки",
		file:{
			actions:"Действия",
		},
		dpad:{
			depName:"Наименование департамента",
			typeName:"Наименование вида проекта",
			dName:"Наименование проекта",
			tenderPrice:"Стоимость тендера",
			bankPrice:"Стоимость банка",
			tenderType:"Тип тендера",
			beginDate:"Дата начала",
			tenderNumber:"Номер тендера",
			endDate:"Дата окончания",
			description:"Описание",
		}
	},
	comboChooseText:'--выберите--',
	// mainMenu: {
	// 	currentLang:'РУС',
	// 	users: 'Пользователи',
	// 	projects:'келісім-шарттар',
	// 	settings: 'анықтамалық деректер',
	// 	graphs :'жобалардың графиктері',
	// },
	hForm:{
		back:"Назад",
		Used:"Использованный",
		dateUsed:"Дата использования",
		budgetUsed:"Использованный бюджет",
		Planned:"Запланированный",
		datePlanned:"Дата планирования",
		budgetPlanned:"Запланированный бюджет",
		Current:"Текущий",
		currentUsed:"Использованный текущий бюджет",
		Warning:"Предупреждение",
		budgetLack:"Недостаток бюджета",
		warning:"Предупреждение",
		budgetDiff:"Разница бюджета",
		addHistory:"Добавить бюджет",
		
	},
	fForm:{
		fType:"Тип документа",
		km:"Километр",
		price:"Цена",
		desc:"Описание",
		fFile:"Выберите файл",
		addFile:"Добавить файл",
		endDate:"Дата окончания догоовора",
		
	},
	dpad:{
		
		addDpad1:"Добавить проект для филиалов",
		addDpad2:"Добавить проект для специалистов ГЗ",
		dForm:{
			endDate:"Дата окончания",
			desc:"Описание",
			tenderNumber:"Номер договора",
			contractNumber:"Номер договора",
			dName:"Наименование проекта",
			beginDate:"Дата начала",
			tenderPrice:"Стоимость тендера",
			departments:"Отделы",
			fType:"Вид проекта",
			tenderType:"Тип тендера",
			bankPrice:"Стоимость банка",
			year:"Год",
			month1:"январь",
			month2:"февраль",
			month3:"март",
			month4:"апрель",
			month5:"май",
			month6:"июнь",
			month7:"июль",
			month8:"август",
			month9:"сентябрь",
			month10:"октябрь",
			month11:"ноябрь",
			month12:"декабрь",
			addDpad1:"Добавить проект для филиалов",
			addDpad2:"Добавить проект для специалистов ГЗ",

		}
	},

	mainMenu: {
		currentLang:'РУС',
		projects:'Договора',

		project:{
			add:"Добавить проект",
			list:"Все проекты",
			dpad1:"Договора для филиалов",
			dpad2:"Договора ДПАД для специалистов ГЗ",
		},
		settings: 'справочные данные',
		setting:{
			companies:"Компании",
			users:"Пользователи",

			
			cats:"Категории",
			departments:"Отделы",
			locations:"",
			level:"Уровни проекта",
			budgets:"Бюджеты",
			status:"Статусы",
			types:"Виды проекта",
			roles:"Роли"
		},
		graphs :'Графическая информация',
	},

//begining of Dag
	pForm:{
		createNew: "Создание проекта",
		pKm: "Километр",
		pPrice: "Стоимость Договора, тенге",
		pAddress: "Адрес",
		organizations: "Подрядная организацию",
		pNumber: "Номер договора",
		pName: "Наименование проекта",
		pDate: "Дата создание проекта",
		endDate: "Дата окончание проекта",
		pTopCover: "(В,С,П. км) верхний слой покрытия",
		pBottomCover: "(Н.С.П. км) нижний слой покрытия",
		pMainCover: "выравнивающий слой/основание",

	},
//end of Dag
	prject: {
		levelName: "Вид работ",
		locationName: "Область",
		pNumber: "Номер договора",
		pPrice: "Стоимость Договора, тенге",
		pKm: "Километр",
		pDate: "Дата заключение договора",
		pAddress: "Адрес",
		ortNames: "Подрядная организацию",
		bActions: "Бюджет",
		Actions: "Действии",
	},


	deliveryList:{
		deliveryListTitle:"Список заказов",
		newDelivery: "Новый",
		inProgress:"В ходе выполнения",
		done:"Выполнено",
		deepSearch:"Глубокий поиск",
		cassReport:"Отчет кассы",
		byOrderNumber:"По номеру заказа",
		byNewOrder:"По новому заказу",
		
	},
	orderDate:"Дата заказа",
	orderNumber:"Номер заказа",
	userInfo:"Информация о клиенте",
	totalProductPrice:"Общая цена продукта",
	takenCostByCash:"Наличными",
	takenCostByCard:"По карте",
	deliveryLoan:"Ссуда заказа",
	orderActions:"Действия",
	showDetails:"Показать детали",
	updateOrder:"Порядок обновления",
	deleteOrder:"Удалить заказ",
	noSlicers:"Слайсеры не выбирал",
	catName:"Слайсеры не выбирал",
	measureName:"Размер",
	productCount:"Количество продуктов",
	doneCount:"Количество завершенных",
	leftCount:"Количество незавершенных",
	productPrice:'Цена продукта',
	totalPrice:"Итоговая цена",
	wareHouseName:"Склад",
	listSlicers:"Резаки",
	completed:"Завершено",
	unCompleted:"Незавершенный",
	colorName:"Цвет товара",
	teacherModule:{
		myDocuments : 'Мои документы',
		newDocument : 'Заполнение нового документа'
	},
	userPage :{
		userList:'Список пользователей'
	},
	wrongFile:"Пожалуйста, переименуйте файл. Имя загружаемого файла не может содержать точку и т.п. спецсимволы !!!",
	
	"userList.lastName":"Фамилия","userList.firstName":"Имя","userList.email":" Электронная почта пользователя","userList.phoneNumber":"Телефонный номер","userList.role":"Роль","userList.userModal":"Регистрация нового пользователя","system.newButton":"Новый","system.updateButton":"Изменить","system.deleteButton":"Удалить","system.searchText":"Значение поиска...","system.recordCountText":"Номер записи","system.defaultSearch":"Поиск","userList.userFormTypeText":"Факультет","userList.userForm.password":"пароль","system.submitButtonText":"Сохранить","system.cancelButtonText":"Отмена","enu.departmentList.departmentName":"Название отдела","enu.departmentList.title":"Список отделов","enu.userList.mainTitle":"Отдел и пользователи","enu.departmentList.departmentNameRu":"Название отдела на русском","userList.departmentName":"Название","enu.documentCategory.title":"Показатель","enu.docCatList.docCatName":"Наименование показателя","enu.docCatList.docCount":"Не более","enu.docCatList.maxPoint":"Максимальный балл","enu.docCatList.insertedDocCount":"Количество пунктов показателя","enu.docCatList.docCatNameRu":"Наименование показателя на русском","enu.docCatList.insertableDocCount":"Максимальное количество документов","enu.documentModule.title":"Модуль документов","enu.blockForm.blockName":"Имя блока","enu.blockForm.blockNameRu":"Имя блока рус","enu.blockForm.maxPoint":"Максимальный балл","enu.blockList.title":"Блоки","enu.docCatList.chooseBlock":"Выбрать блок","enu.documentCategory.blockListName":"Блок","system.error.chooseBlock":"Выберите блок","enu.error.wrongPointMsg":"Вы указали балл больше чем допустимо. Возможный максимальный балл","enu.error.unKnownError":"Произошла ошибка, попробуйте еще раз.","enu.documentList.title":"Список документов","enu.docList.docName":"Документ","enu.docList.chooseDocCat":"Выберите категорию документа","enu.docForm.docName":"Наименование документа","enu.docForm.docNameRu":"Наименование  документа на русском","system.error.chooseBlockOrDocCat":"Вы не выбрали категорию блока или документа","userList.userForm.chooseCatText":"Категории доступные эксперту","enu.teacherDocList.categoryName":"Название категории","enu.teacherDocList.takenPoint":"После экспертизы","enu.teacherDocForm.shortDescription":"Краткое описание (ссылка на интернет ресурсы и т.п.)","enu.teacherDocForm.shortDescriptionRu":"Краткое описание на русском языке","enu.teacherDocForm.chooseFile":"Выберите файл или перетащите сюда ...","enu.teacherDocForm.dropHere":"Перетащите файл сюда ...","enu.teacherDocForm.addRow":"+ Добавить","enu.teacherDocForm.rowWarnMsg":"вы превысили максимальное количество вводимых документов по выбранной категории","enu.teacherDocForm.fillAllError":"Пожалуйста, введите всю информацию.","enu.teacherDocForm.noFileError":"Пожалуйста, выберите файл.","enu.docCatForm.chooseIsTeam":"Общий показатель","enu.teacherForm.networkOrFileError":"Произошла сетевая ошибка или вы выбрали огромный файл","enu.teacherForm.incorrectFileError":"Вы загрузили неверный файл","enu.teacherForm.docCountInformationMsg":"Обратите внимание, количество загружаемых документов ограничено","enu.teacherForm.allowedUploadSizeMsg":"Допустимое количество загрузок","enu.teacherForm.uploadedSizeMsg":"Количество загрузок","enu.teacherForm.teamInputMsg":"Количество авторов","enu.teacherDocList.plannedPoint":"Возможный балл","enu.teacherDocListSunDocCatListTitle":"Категории документов","enu.system.closeSubCategory":"Свернуть","enu.system.closeSubDocument":"Свернуть","enu.landing.mainMenu.top100":"ЛУЧШИЙ ПРЕПОДАВАТЕЛЬ ВУЗА","enu.landing.copyrightText":"© Евразийский национальный университет имени Л.Н. Гумилева","enu.landing.departmentsText":"Отделы","enu.landing.teacherForm.workPosition":"Должность","enu.landing.teacherForm.dateOfBirth":"Дата рождения, число, месяц","enu.landing.teacherForm.dateOfPositionShort":"Стаж работы","enu.landing.teacherForm.education":"Образование (какое учебное заведение, факультет, в каком году окончил)","enu.landing.teacherForm.degree":"Ученая степень/звание","enu.landing.teacherForm.adress":"Домашний адрес с указанием индекса","enu.landing.teacherForm.regNumber":"ИИН","enu.landing.teacherForm.prise":"Награды, поощрения","system.loginTxt":"Авторизоваться","system.regTxt":"Регистрация","system.login.userName":"e-mail","system.login.userPassword":"Пароль","enu.teacherForm.isFifteen1":"больше 15 лет","enu.teacherForm.isFifteen2":"до 15 лет","enu.teacherForm.missingDepartmentMsg":"Пожалуйста, выберите отдел.","enu.teacherForm.notSamePasswordMsg":"Вы ввели разные пароли.","enu.teacherForm.reEnterPassword":"Пожалуйста, введите пароль еще раз.","enu.system.contactUsTxt":"Контакты","enu.teacherForm.thirdName":"Отчество","enu.teacherForm.idCardGroupTxt":"Данные удостоверения личности","enu.teacherForm.idCardNumberTxt":"Номер","enu.teacherForm.IdCardDateTxt":"Дата выдачи","enu.teacherForm.GivenOrgTxt":"Орган выдачи","enu.teacherForm.givenOrg1":"МВД РК","enu.teacherForm.givenOrg2":"МЮ РК","enu.teacherForm.givenOrgChooseText":"Выберите орган выдачи","enu.teacherForm.missingPositionTxt":"Укажите должность","enu.teacherForm.missingDegreeTxt":"Укажите ученую степень","enu.teacherForm.missingDateOfBirthTxt":"Укажите день рождения","enu.teacherForm.missingIdCardDateTxt":"Укажите день выдачи удостоверения личности","enu.teacherForm.wrongInTxt":"Неверный ИИН","enu.teacherForm.wrongIdCardTxt":"Неверный номер удостоверения личности","enu.teacherDocList.docActions":"Действия","enu.teacherDocList.downloadDocument":"Скачать","enu.teacherDocList.fillMenuName":"enu.teacherDocList.fillMenuName","enu.teacherDocList.yearPlanning":"План на весь год","enu.teacherDocList.fillDocTheadWork":"Наименование видов работ","enu.teacherDocList.fillDocTheadMeasure":"Единица измерения","enu.teacherDocList.fillDocTheadDependency":"Основание для реализации указанного вида работы (с указанием предполагаемого наименования)","enu.teacherDocList.fillDocDateTitle":"Срок реализации","enu.teacherDocList.fillDocBeginDate":"Начало","enu.teacherDocList.fillDocEndDate":"Окончание","enu.teacherDocList.fillDocOfficialTitle":"Приложение 3\r\nк Правилам присвоения звания\r\n«Лучший преподаватель вуза»,\r\nутвержденные приказом\r\nисполняющего обязанности\r\nМинистра образования и науки\r\nРеспублики Казахстан\r\nот 16 марта 2015 года № 124\r\n","enu.teacherDocList.fillDocH1Title":"Годовой план-график работ","enu.teacherDocList.FillDocCategoryError":"Вышеуказанная категория работ должна содержать хотя бы одну заполненную работу.","enu.teacherDocList.FillDocDocError":"Вышеуказанные работы должны быть заполнены.","enu.teacherDocList.FillDocSignature":"Участник Конкурса","enu.teacherDocList.FillDocPrint":"Распечатать",
	lms:{
		login:"Войти в систему",
		register:"Зарегистрироваться в системе",
		userList:{
			systemUsers:'Пользователи системы',
			firstName:'Имя',
			lastName:'Фамилия',
			userName:'Логин',
			phoneNumber:'Роль в системе',
			role :'Жүйедегі рөлі',
			blocking:"Блокировка",
			unblocking:"Разблокировка",
			enroll:"Зарегистрироваться"
		},
		
		userForm:{
			modalTitle:"Информация о пользователе",
			userType:"Тип пользователя",
			lastName:"Фамилия",
			firstName:"Имя",
			thirdName:"Отчества",
			phoneNumber:"Номер телефона",
			email:"Эл. адрес",
			password:"Пароль",
			repeatPassword:"Повторите пароль",
			addUser:"Добавить пользователя",
			clear:"Наглядная форма",
			roleConfirm:"Вы должны выбрать тип пользователя",
			passwordsNotMatchError:"Введенные вами пароли не совпадают!!!",
			dublicatedEmail:"Электронная почта уже зарегистрирована !!!",
			wrongLogin:"Электронная почта или пароль неверны."
		},
		courseList:{
			mainTitle:"Управление курсом и модулем",
			courseList:"Список курсов",
			courseName:"Название курса",
			moduleCount:"Модули",
			courseCount:"Курсы",
			studentCount:"Ученики",
			status:"Статус",
			delete:"Удалить",
			active:"Активный",
			inActive:"Неактивный",
			newCourse:"Новый курс [+]",
			moduleName:"Модуль",
			lectureCount:"Лекция",
			labCount:"Лабротория",
			description:"Описание",
			isFree:"Бесплатно ?",
			no:"Нет",
			yes:"Да",
			isDefault:"Главное или не главное",
			buildIntro:"Введение в курс сборки"
		},
		add:"Добавить запись",
		clear:"Наглядная форма",
		moduleForm:{
			modalTitle:"Курс создавать и обновлять",
			chooseCourses:"Выберите курсы, которые будут включать модуль"
		},
		courseForm:{
			chooseFile:"Выбрать файл ...",
			dropFile:"Перетащите файл сюда..."
		},
		moduleList:{
			moduleFiles:"Детали для модулей",
			create:"Сборка частей модуля",
			createModule:"Создать модуль"
		},
		moduleForm:{
			modalTitle:"Создавайте и обновляйте курсы",
			chooseCourses:"Выбрать курсы"
		},
		serverList:{
			mainTitle:"Серверы для строительной лаборатории",
			serverName:"Имя сервера",
			ipAddress:"Сервер IP",
			description:"Описание",
			imagePath:"Логотип",
			userName:"Имя пользователя сервера",
			password:"Пароль сервера",
			protocol:"Сервер протоколы",
			hasPublicIp:"У сервера есть внешний ip ?",
			ami:"AMI",
			ipMask:"IPMASK",
			instanceType:"Instance type"
		},
		labList:{
			mainTitle:"Лаборатории для каждого модуля",
			chooseServers:"Выберите серверы, которые будут использоваться в лаборатории",
			labName:"Название лаборатории",
			labText:"Описание лаборатории",
			labEmbedded:"Лабораторный видеоурок",
			chooseScorm:"SCORM-файл для лаборатории",
			labFiles:"Лабораторные материалы, файлы",
			createLab:"Создать лабораторию",
			servers:"Серверы",
			lectureName:"Название лекции"

		},
		videoList:{
			mainTitle:"Список видео",
			name:"Имя",
			description:"Описание",
			showVideo:"Показать видео",
			videoPath:"Код видео",
			bottomText:"Нижний текст видео",
			createVideo:"Создать видео"
		},
		catList:{
			createCat:"Создать категорию",
			catName : "Создать имя"
		},
		add:"добавить",
		clear:"очистить",
		chooseImage:"Выберите изображение",
		detailSuccess:"Компонент успешно создан.",
		image:"Компонент изображения",
		scorm:"Скорм компонент",
		video:"Видео компонент",
		text:"Текстовый компонент",
		detailComps:"Детали компонентов",
		courseCategory:"Категория курса [+]",
		chooseCats:"Выберите категории",
		isDefault:"Лекция по умолчанию?",
		vps:{
			manageVps:"Управление VPS",
			vpsName:"Имя VPS",
			manageVps:"Server vpses",
			chooseVpses:"Выберите VPS"
		},
		myCourses:"Мои курсы",
		mustLoginError:"Вы должны войти в систему, чтобы просмотреть курс!!!",
		selectCourses:"Выбор курсов."
	}

};